const isLocalhost = window.location.hostname === "localhost";

export const msalREMA = {
  auth: {
    clientId: "3991afa8-41a0-4bc5-97ef-f871ff70feb1",
    authority:
      "https://login.microsoftonline.com/bbf77a8f-7fa8-45a0-81db-7ad345a349c0",
    redirectUri: isLocalhost
      ? "http://localhost:5173"
      : "https://wimulerdo.rema.no", // Dynamically adjust
  },
  cache: {
    cacheLocation: "sessionStorage", // Store tokens in sessionStorage for better security
    storeAuthStateInCookie: true, // Helps with authentication issues across tabs
  },
};

export const loginRequestREMA = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

export const loginRequestWiMuleCloud = {
  scopes: [
    "api://9d209699-12e0-49a7-96c5-a907d8ca3431/access_as_user"
  ],
};


export const msalWIOSS = {
  auth: {
    clientId: "e884cc5d-e8fc-4af3-94fb-998fb1b7d34d",
    authority:
      "https://login.microsoftonline.com/4f9ba387-2880-45f7-9cdc-5697e8c82f9a",
    redirectUri: isLocalhost
      ? "http://localhost:5173"
      : "https://cloud.wioss.no", // Dynamically adjust
  },
  cache: {
    cacheLocation: "sessionStorage", // Store tokens in sessionStorage for better security
    storeAuthStateInCookie: true, // Helps with authentication issues across tabs
  },
};

export const entraConfigs = {
  rema: msalREMA,
  wioss: msalWIOSS,
};
